import { React } from 'react';
import ServiceSection from '../../../../ServiceSection/ServiceSection';
import SatelliteTopics from '../../../SatelliteTopics/SatelliteTopics';
import satelliteIcon from '../../../satelliteIcon';

const CostCustomSoftware3 = props => (
    <ServiceSection noPadBottom noPadTitle singleTitle icon={satelliteIcon} {...props} page="costCustomSoftware" section="factors">
        <div className='TextGroup Satellite'>
            <SatelliteTopics t={props.t} prefix="costCustomSoftware:factors" noGroupTitle tag="h3" first noPadBottom />
        </div>
    </ServiceSection>
);

export default CostCustomSoftware3;
